import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { KeyUri, config } from "../key";
import { toast } from "react-toastify";

const initialState = {
  currentTerms: null,
  loading: false,
  hasError: false,
};

export const termsSlice = createSlice({
  name: "terms",
  initialState,
  reducers: {
    getTermsRequest: (state) => {
      state.loading = true;
      state.hasError = false;
    },
    getTermsFailure: (state) => {
      state.loading = false;
      state.hasError = true;
    },
    getCurrentTermsSuccess: (state, action) => {
      state.loading = false;
      state.currentTerms = action.payload;
      state.hasError = false;
    },
  },
});

export const {
  getTermsRequest,
  getTermsFailure,
  getCurrentTermsSuccess,
} = termsSlice.actions;

export const termsSelector = (state) => state.terms;

export const fetchUserTerms = () => async (dispatch) => {
  console.log("✅ fetchUserTerms is running...");

  dispatch(getTermsRequest());

  const fullUrl = `${KeyUri.BACKEND_URI}/terms/user-terms`;
  console.log("🟡 Full API URL:", fullUrl);
  console.log("🟡 Headers sent:", config.headers);

  try {
    const { data } = await axios.get(fullUrl, config);
    console.log("✅ Response data:", data);

    dispatch(getCurrentTermsSuccess(data.userTerms));
  } catch (error) {
    console.error("❌ Error fetching user terms:", error.response?.data || error.message);
    dispatch(getTermsFailure());
  }
};





export default termsSlice.reducer;
